import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './root-cmp';
import './assets/scss/styles.scss'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
